import { FileSpreadsheet, Users, Zap } from "lucide-react";

import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import SpotlightCard from "../../SpotlightCard";
import GlobalHeadline from "../../../GlobalHeadline";
import { siteSections } from "../../../../content/siteSections";

const icons = { FileSpreadsheet, Users, Zap };

/**
 * Bottleneck problem cards.
 * Translation: Bottleneck problem cards.
 *
 * @returns {JSX.Element} Problems section.
 */
const Problems = () => (
  <section id="problems" className="section-block">
    <div className="section-shell">
      <SectionHeading
        eyebrow={siteSections.problems.eyebrow}
        title={siteSections.problems.title}
      />

      <div className="card-grid card-grid--three">
        {siteSections.problems.cards.map((card, index) => {
          const Icon = icons[card.icon];

          return (
            <Reveal key={card.title} delay={index * 100}>
              <SpotlightCard className="glass-panel section-card group">
                <div className="section-card__header">
                  <Icon className="section-card__icon" strokeWidth={1.25} />
                  <GlobalHeadline as="h3">{card.title}</GlobalHeadline>
                </div>
                <p>{card.description}</p>
              </SpotlightCard>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Problems;
